import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac6c26c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weather-detail-view" }
const _hoisted_2 = { class: "station-selector-wrapper" }
const _hoisted_3 = { class: "updated-at" }
const _hoisted_4 = { class: "top-pane" }
const _hoisted_5 = { class: "panel wind-meter-panel" }
const _hoisted_6 = { class: "panel others-panel" }
const _hoisted_7 = { class: "others-panel-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon wind" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "平均風速")
], -1))
const _hoisted_9 = { class: "others-panel-item-body" }
const _hoisted_10 = { class: "value odd" }
const _hoisted_11 = { class: "others-panel-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon wind" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, [
    /*#__PURE__*/_createTextVNode(" １０分間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 最大瞬間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 風向風速 ")
  ])
], -1))
const _hoisted_13 = { class: "others-panel-item-body" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "value odd" }
const _hoisted_16 = { class: "others-panel-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon wind" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, [
    /*#__PURE__*/_createTextVNode(" 日最大瞬間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 風向風速 ")
  ])
], -1))
const _hoisted_18 = { class: "others-panel-item-body" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "value odd" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "panel others-panel" }
const _hoisted_23 = { class: "others-panel-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon tempature" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "気温")
], -1))
const _hoisted_25 = { class: "others-panel-item-body" }
const _hoisted_26 = { class: "value odd" }
const _hoisted_27 = { class: "others-panel-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon humid" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "湿度")
], -1))
const _hoisted_29 = { class: "others-panel-item-body" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "others-panel-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "累計雨量")
], -1))
const _hoisted_33 = { class: "others-panel-item-body" }
const _hoisted_34 = { class: "value odd" }
const _hoisted_35 = { class: "others-panel-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "日積算雨量")
], -1))
const _hoisted_37 = { class: "others-panel-item-body" }
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "others-panel-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "降雨強度")
], -1))
const _hoisted_41 = { class: "others-panel-item-body" }
const _hoisted_42 = { class: "value odd" }
const _hoisted_43 = { class: "others-panel-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon humid" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "現地気圧")
], -1))
const _hoisted_45 = { class: "others-panel-item-body" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "bottom-pane" }

import { computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment'
import WindMeter from '@/components/common/WindMeter.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import SimpleHistoriesPanel from '@/components/rain_detail/SimpleHistoriesPanel.vue'
import { usePresentStore } from '@/stores/presentStore'
import { windDirectionLabel } from '@/lib/constants'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { renderValue } from '@/lib/formatter'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const presentStore = usePresentStore()
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()

const params = computed(() => {
  if (globalStore.currentStation === undefined) {
    return {}
  }

  const stationId = globalStore.currentStation.stationId as string
  const updatedAt = presentStore.getTime(stationId, '取得日時: YYYY年MM月DD日 HH:mm')
  const windDirection = presentStore.getValue(stationId, 'moveWdMin10')
  const avgWindStrength = renderValue(presentStore.getValue(stationId, 'moveWsMin10'), 1)
  const windStrength = renderValue(presentStore.getValue(stationId, 'moveMaxWsMin10'), 1)
  const maxWindDirection = presentStore.getValue(stationId, 'maxMoveMaxWdMin10OfDay')
  const maxWindStrength = renderValue(presentStore.getValue(stationId, 'maxMoveMaxWsMin10OfDay'), 1)
  const maxWindTime = presentStore.getValue(stationId, 'maxMoveMaxWsMin10OfDayTime')
  const tempature = renderValue(presentStore.getValue(stationId, 'temp'), 1)
  const humid = renderValue(presentStore.getValue(stationId, 'humid1'), 1)
  const press = renderValue(presentStore.getValue(stationId, 'press1'), 1)
  const rainDay = renderValue(presentStore.getValue(stationId, 'rainDay'), 1)
  const rainRui = renderValue(presentStore.getValue(stationId, 'rainRui'), 1)
  const rainfall = renderValue(presentStore.getValue(stationId, 'rainfall'), 1)

  return {
    updatedAt,
    windDirection,
    avgWindStrength,
    windStrength,
    maxWindDirection,
    maxWindStrength,
    maxWindTime,
    tempature,
    humid,
    press,
    rainDay,
    rainRui,
    rainfall,
  }
})

const maxWindTimeText = computed(() => {
  const time = params.value.maxWindTime

  if (time === undefined) {
    return '-'
  }

  return moment(time).format('HH:mm')
})

const maxWindDirectionText = computed(() => {
  const direction = params.value.maxWindDirection

  return windDirectionLabel(direction)
})

const windDirectionText = computed(() => {
  const direction = params.value.windDirection

  return windDirectionLabel(direction)
})

const attachCurrentStation = () => {
  const station = initDataStore.initData.stations.findById(route.params.stationId as string)
  const areaCode = station?.areaCode[0]

  if (!areaCode) {
    return
  }

  const area = initDataStore.areaList.find(area => area.id === areaCode)

  globalStore.currentArea = area
  globalStore.currentStation = station
}

onMounted(() => {
  attachCurrentStation()
})

watch(() => initDataStore, attachCurrentStation)

watch(
  () => globalStore.currentStation,
  () => {
    const fieldId = globalStore.currentStation?.fieldId || []

    if (fieldId.includes('water_level')) {
      router.push(`/water_detail/${globalStore.currentStation?.stationId}`)
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StationSelector, { "station-type": "all" }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(params).updatedAt), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(WindMeter, {
          windDirection: _unref(params).windDirection,
          windStrength: _unref(params).avgWindStrength,
          size: "middle"
        }, null, 8, ["windDirection", "windStrength"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(params).avgWindStrength) + " m/s", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(params).windStrength) + " m/s", 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(windDirectionText)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(params).maxWindStrength) + " m/s", 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(maxWindDirectionText)), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(maxWindTimeText)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(params).tempature) + " ℃", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(params).humid) + " %", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(params).rainRui) + " mm", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(params).rainDay) + " mm", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(params).rainfall) + " mm/h", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(params).press) + " hPa", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createVNode(SimpleHistoriesPanel, { class: "hide-sp" })
    ])
  ]))
}
}

})